import { PageInfo } from '../../../shared/models/queryparams/pageinfo.model';
import { SortInfo } from '../../../shared/models/queryparams/sortinfo.model';
import { FilterTemplateResponseModel } from './filter-template.response.model';

export class ReportGridDataRequest {
  constructor(public template: FilterTemplateResponseModel, public startDate: Date, public endDate: Date,
    public pageInfo: PageInfo, public sortInfo: SortInfo, public searchTextGrid: any ) {
     }
}


export class ReportExportDataRequest {
  constructor(public template: FilterTemplateResponseModel, public startDate: Date, public endDate: Date,
    public sortInfo: SortInfo, public headers: any[] = []) { }
}

export class LobbyDetailViewGridRequest extends ReportGridDataRequest { }
export class LobbyDetailViewExportRequest extends ReportExportDataRequest { }
export class LobbyEditorGridRequest extends ReportGridDataRequest { }
export class LobbyEditorExportRequest extends ReportExportDataRequest { }

//export class ReportGridDataResponse {
//  public currentPageNumber: number;
//  public pageSize: number;
//  public data: any;
//  public totalRowCount: number;
//}
